/* =========================================================
   CHAGUAL — Header offset (PLP) v3
   Objetivo: evitar "doble offset" (franja blanca) en primer load
   y mantener que el header sticky NO tape el H1/intro.

   Variables que setea en :root:
   --chagual-header-cover : altura real del header fixed/sticky que tapa contenido
   --chagual-header-push  : cuánto padding-top adicional necesita la PLP (0 si el tema ya empuja el contenido)
   --chagual-header-offset: alias legacy (igual a --chagual-header-cover)

   Estrategia:
   push = max(0, cover - sectionTop)
   donde sectionTop = getBoundingClientRect().top de .shopify-section--collection-template.under-menu

   Eventos:
   - DOMContentLoaded / load / pageshow (bfcache)
   - shopify section load/select
   - turbo/turbolinks/spf
   - observers (ResizeObserver + MutationObserver)
   ========================================================= */

(function () {
  'use strict';

  var ROOT = document.documentElement;

  function px(n) { return Math.max(0, Math.round(n || 0)) + 'px'; }

  function getHeaderCoverPx() {
    // Turbo / Pixel Union: #header suele ser el header móvil fixed
    var header = document.querySelector('#header') || document.querySelector('header');
    if (!header) return 0;

    var cs = window.getComputedStyle(header);
    var pos = cs.position;

    // Solo si realmente "tapa" (fixed/sticky)
    if (pos !== 'fixed' && pos !== 'sticky') return 0;

    // Altura visible
    var h = header.getBoundingClientRect().height || header.offsetHeight || 0;
    return h;
  }

  function getCollectionSection() {
    return document.querySelector('.shopify-section--collection-template.under-menu');
  }

  function recalc() {
    try {
      var cover = getHeaderCoverPx();

      // Publicamos cover (y alias legacy)
      ROOT.style.setProperty('--chagual-header-cover', px(cover));
      ROOT.style.setProperty('--chagual-header-offset', px(cover));

      var sec = getCollectionSection();
      if (!sec) {
        ROOT.style.setProperty('--chagual-header-push', '0px');
        return;
      }

      // Si el tema ya empuja el contenido, secTop ~ cover.
      // Si NO lo empuja (secTop ~ 0), necesitamos push ~ cover.
      var secTop = sec.getBoundingClientRect().top || 0;
      var push = Math.max(0, cover - secTop);

      // Guardrail: evita valores absurdos (bugs por medición)
      if (push > 200) push = cover;

      ROOT.style.setProperty('--chagual-header-push', px(push));
    } catch (e) {
      // Falla silenciosa (no ensuciar consola en producción)
    }
  }

  function scheduleBurst() {
    recalc();
    // El tema puede ajustar clases/posiciones después del primer paint
    setTimeout(recalc, 0);
    setTimeout(recalc, 50);
    setTimeout(recalc, 150);
    setTimeout(recalc, 300);
    setTimeout(recalc, 600);
    setTimeout(recalc, 1000);
  }

  // Eventos estándar
  document.addEventListener('DOMContentLoaded', scheduleBurst, { passive: true });
  window.addEventListener('load', scheduleBurst, { passive: true });

  // bfcache (Safari iOS)
  window.addEventListener('pageshow', function () { scheduleBurst(); }, { passive: true });

  // Shopify theme editor
  document.addEventListener('shopify:section:load', scheduleBurst);
  document.addEventListener('shopify:section:select', scheduleBurst);

  // Turbo / Turbolinks / SPF (según tema)
  document.addEventListener('turbo:load', scheduleBurst);
  document.addEventListener('turbolinks:load', scheduleBurst);
  document.addEventListener('spf:load', scheduleBurst);
  document.addEventListener('spf:afterload', scheduleBurst);

  // Observers: si cambian alturas/clases, recalcular
  try {
    var headerEl = document.querySelector('#header') || document.querySelector('header');
    if (headerEl && 'ResizeObserver' in window) {
      var ro = new ResizeObserver(function () { recalc(); });
      ro.observe(headerEl);
    }
  } catch (e) {}

  try {
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () { recalc(); });
      mo.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
      mo.observe(ROOT, { attributes: true, attributeFilter: ['class', 'style'] });
    }
  } catch (e) {}

  // Primera corrida inmediata
  scheduleBurst();
})();


/* =========================================================
   CHAGUAL — PDP anchor helper (medidas) v1
   Fix: en algunos móviles/skins, los anchors internos pueden quedar anulados por
   handlers del theme. Este listener (capture) fuerza scroll + offset y abre <details>.
   Alcance: solo #pdp-medidas y links .pdp-measures-inline__a
========================================================= */
(function () {
  function getHeaderCover() {
    var v = getComputedStyle(document.documentElement).getPropertyValue('--chagual-header-cover');
    var n = parseFloat(String(v || '').replace('px',''));
    return isFinite(n) ? n : 0;
  }

  function scrollToTarget(target, hash) {
    try {
      if (target && target.tagName === 'DETAILS' && !target.open) target.open = true;
    } catch (e) {}

    var cover = getHeaderCover();
    var extra = 12;
    var rect = target.getBoundingClientRect();
    var y = window.pageYOffset + rect.top - cover - extra;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });

    try { history.pushState(null, '', hash); } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href^="#"]') : null;
    if (!a) return;

    var hash = a.getAttribute('href') || '';
    if (hash.length < 2) return;

    var id = '';
    try { id = decodeURIComponent(hash.slice(1)); } catch (err) { id = hash.slice(1); }

    // Scope: only medidas anchor(s)
    if (!(id === 'pdp-medidas' || a.classList.contains('pdp-measures-inline__a'))) return;

    var target = document.getElementById(id);
    if (!target) return;

    e.preventDefault();
    scrollToTarget(target, hash);
  }, true);

  // If the page loads with #pdp-medidas in the URL, honor it after layout settles.
  window.addEventListener('load', function () {
    if (!location.hash) return;
    var hash = location.hash;
    var id = hash.slice(1);
    if (id !== 'pdp-medidas') return;
    var target = document.getElementById(id);
    if (!target) return;
    setTimeout(function () { scrollToTarget(target, hash); }, 50);
  });
})();
